var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Colors } from '@pacem/pacem-foundation';
import { Utils, P, PCSS, CustomElement, Defaults, ViewChild } from '@pacem/pacem-core';
import { PacemBaseElement } from './types-components';
//namespace Pacem.Components.Scaffolding {
let PacemColorInputElement = class PacemColorInputElement extends PacemBaseElement {
    acceptValue(val) {
        const parsed = this._parseValue(val);
        if (parsed != null) {
            this._tint.value = parsed.tint;
            this._alpha.value = parsed.alpha.toString();
        }
    }
    convertValueAttributeToProperty(attr) {
        return attr;
    }
    onChange(evt) {
        // https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/669685/ (bug open since Aug 2014!)
        const alpha = this._alpha.valueAsNumber || parseInt(this._alpha.value);
        const tint = this._tint.value;
        const value = this.value = this._getValue(tint, alpha);
        return Utils.fromResult(value);
    }
    constructor() {
        super();
    }
    toggleReadonlyView(readonly) {
        this._wrapper.hidden = readonly;
        this._span.hidden = !readonly;
    }
    _getValue(tint, alpha) {
        // #rrggbb
        if (isNaN(alpha) || alpha === 100)
            return tint;
        const rgb = Colors.parse(tint);
        rgb.a = alpha * .01;
        return Colors.stringify(rgb);
    }
    _parseValue(val) {
        const rgb = Colors.parse(val);
        if (Utils.isNullOrEmpty(rgb)) {
            return null;
        }
        return { tint: Colors.stringify({ r: rgb.r, g: rgb.g, b: rgb.b }), alpha: rgb.a * 100 };
    }
    getViewValue(value) {
        return value;
    }
    get inputFields() {
        return [this._tint, this._alpha];
    }
};
__decorate([
    ViewChild('input[type=color]')
], PacemColorInputElement.prototype, "_tint", void 0);
__decorate([
    ViewChild('input[type=number]')
], PacemColorInputElement.prototype, "_alpha", void 0);
__decorate([
    ViewChild(`.${PCSS}-viewfinder`)
], PacemColorInputElement.prototype, "_wrapper", void 0);
__decorate([
    ViewChild(`.${PCSS}-readonly`)
], PacemColorInputElement.prototype, "_span", void 0);
PacemColorInputElement = __decorate([
    CustomElement({
        tagName: P + '-input-color', template: `<div class="${PCSS}-viewfinder">
<${P}-panel class="${PCSS}-input-color" css="{{ { \'background-color\': :host.viewValue } }}"><input type="color" class="${PCSS}-input" /></${P}-panel>
<input class="${PCSS}-input" type="number" min="0" max="100" step="1" value="100" />
</div>
<${P}-span class="${PCSS}-readonly" css="{{ { \'background-color\': :host.viewValue } }}"></${P}-span>`,
        shadow: Defaults.USE_SHADOW_ROOT
    })
], PacemColorInputElement);
export { PacemColorInputElement };
